import { translate } from "@/lib/i18n";

const MAP = [
  ["owner only", "err_owner_only"], ["forbidden", "err_forbidden"], ["amount must be positive", "err_amount_positive"],
  ["supplier not found", "err_supplier_missing"], ["invalid return amount", "err_return_amount"], ["order needs items", "err_order_items"],
  ["bad status", "err_bad_status"], ["insufficient vault balance", "err_vault_balance"], ["transfer must equal", "err_transfer_amount"],
  ["amount must match", "err_transfer_amount"], ["shift_close must be a deposit", "err_transfer_kind"], ["already open", "err_already_open"],
  ["already closed", "err_already_closed"], ["already invoiced", "err_already_invoiced"], ["closed shift not found", "err_shift_missing"],
  ["another shift is open", "err_shift_open"], ["insufficient stock", "err_stock"], ["slot_blocked", "slot_blocked"], ["server error", "err_server"],
];

export function syncErrText(lang, raw) {
  const s = String(raw || "");
  const hit = MAP.find(([k]) => s.includes(k));
  if (hit) return translate(lang, hit[1]);
  if (s.startsWith("plan_limit")) return translate(lang, s);
  return s.replace(/^invalid data: /, "").replace(/^'(\w+)'$/, (_, f) => translate(lang, "err_missing_field", { f }));
}
